<div class="sign-up-div">
  <div class="box design-box-thin">
    <img src="/assets/images/wave-2.svg" alt="wave" />
  </div>
  <div class="image-box">
    <img src="/assets/images/intro-img.svg" alt="img" />
  </div>
  <div class="form-div">
    <img src="/assets/images/logo.svg" alt="Future Nav – Compass logo" class="logo" />
    @if (showTerms) {
      <app-tandc (showTermsEmitter)="getTermsEmitter($event)" />
    } @else if (showVerifyAccount) {
      <app-verify-account (backEmitter)="getFormSubmittedEmitter($event)" />
    } @else if (showSignIn) {
      <app-sign-in-form (createAccountEmitter)="getSignInEmitter($event)" />
    } @else {
      <app-sign-up-form 
        (showTermsEmitter)="getTermsEmitter($event)"
        (formSubmittedEmitter)="getFormSubmittedEmitter($event)"
        (signInEmitter)="getSignInEmitter($event)" 
      />
    }
  </div>
  <div class="box design-box-wider">
    <img src="/assets/images/wave-1.svg" alt="wave" />
  </div>
</div>
